import logo from "./logo.svg";
import "./App.css";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./component/UI/Dashboard/Dashboard";
import Main from "./component/UI/Main";
import ProjectMain from "./component/UI/Project/ProjectMain";
import AddProject from "./component/UI/Project/AddProject";
import CustomerTable from "./component/UI/Customer/CustomerTable";
import AddCustomer from "./component/UI/Customer/AddCustomer";
import VendorTable from "./component/UI/Vendors/VendorTable";
import Employee from "./component/UI/Employees/Employee";
import AddVendor from "./component/UI/Vendors/AddVendor";
import Addemployee from "./component/UI/Employees/Addemployee";
import PaymentTable from "./component/UI/Payment/PaymentTable";
import UserMangementTAble from "./component/UI/UserMangement/UserMangementTAble";
import AdduserMange from "./component/UI/UserMangement/AdduserMange";
import Settings from "./component/UI/Settings/Settings";
import Currency from "./component/UI/Settings/Currency";
import Process from "./component/UI/Settings/Process";
import Role from "./component/UI/Settings/Role";
import Payment from "./component/UI/Settings/Payment";
import Upload from "./component/UI/Upload/Upload";
// import Invoice from "./component/UI/Invoice/Invoice";
import Invoice from "./component/Invoice";
import Login from "./component/UI/Login";
import ResetPW from "./component/UI/ResetPw";
import AuthProvider from "./context/AuthProvider";
import EmployeeProject from "./component/UI/Project/EmployeeProject";
import Profile from "./component/UI/Settings/Profile";
import ProtectedRoute from "./component/ProtectedRoute";
import Page404 from "./component/Page404";
import Unauth from "./component/Unauth";
import RootRedirect from "./component/RootRedirect";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter >
        <Routes>
          {/* Root path — redirect based on auth status */}
          <Route path="/" element={<RootRedirect />} />

          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<ResetPW />} />
          <Route path="/unauthorized" element={<Unauth/>} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute allowedRoles={["super-admin","employee"]} />}>
            <Route path="/" element={<Main />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="project" element={<ProjectMain />} />
              <Route path="profile" element={<Profile />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["super-admin"]} />}>
            <Route path="/" element={<Main />}>
              <Route path="customer" element={<CustomerTable />} />
              <Route path="addcustomer" element={<AddCustomer />} />
              <Route path="vendor" element={<VendorTable />} />
              <Route path="addvendor" element={<AddVendor />} />
              <Route path="employee" element={<Employee />} />
              <Route path="addemployee" element={<Addemployee />} />
              <Route path="payment" element={<PaymentTable />} />
              <Route path="user-management" element={<UserMangementTAble />} />
              <Route path="adduser-management" element={<AdduserMange />} />
              <Route path="settings" element={<Settings />} />
              <Route path="currency" element={<Currency />} />
              <Route path="process" element={<Process />} />
              <Route path="role" element={<Role />} />
              <Route path="payments" element={<Payment />} />
              <Route path="upload" element={<Upload />} />
              <Route path="invoice" element={<Invoice />} />
              <Route path="invoice/:id" element={<Invoice />} />
            </Route>
          </Route>

          {/* Catch-all 404 — must be last */}
          <Route path="*" element={<Page404 />} />
        </Routes>

        {/* Toaster notification */}
        <Toaster
          position="top-right"
          containerStyle={{
            top: 10,
          }}
          toastOptions={{
            className: "",
            style: {
              background: "#575555",
              color: "white",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
